export default class PrintPage {
    private printButton: HTMLElement;

    constructor() {
        this.printButton = document.getElementById("print-page");
        this.printButton.addEventListener("click", () => window.print());
    }
}
